import { globalError, TYPE_ERROR } from 'app/shared/error/error-global';
import { setStylesProperties } from 'app/shared/util/method-util';
import { cmsApi } from '../api';
import { setCmsContent, setCmsCreated, setMarketing } from './store/cms-actions';
import { CmsPageContentType } from '../tools/types';

export const getAppStylesFromCms = () => async dispatch => {
  const result = await cmsApi.getPageContentFromCms(CmsPageContentType.APP_GLOBAL_TYPE);
  const resultRecap = await cmsApi.getPageContentFromCms(CmsPageContentType.CUSTOMER_SUBSCRIPTION_SUMMARY_CONTENT);

  if (result.isFailure) {
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  await setStylesProperties(result.getValue());
  await dispatch(setCmsCreated());
  await dispatch(setCmsContent({ content: result.getValue(), type: CmsPageContentType.APP_GLOBAL_TYPE }));
  await dispatch(setCmsContent({ content: resultRecap.getValue(), type: CmsPageContentType.CUSTOMER_SUBSCRIPTION_SUMMARY_CONTENT }));
};

export const getPageContentFromCms = (pageContentType: string) => async (dispatch, getState) => {
  const { content } = getState().cms;

  if (content[pageContentType] === undefined) {
    const result = await cmsApi.getPageContentFromCms(pageContentType);

    if (result.isFailure) {
      globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
      return;
    }

    await dispatch(setCmsContent({ content: result.getValue(), type: pageContentType }));
  }
};

export const getMarketingCampaignContentFromCms = () => async dispatch => {
  const result = await cmsApi.getMarketingCampaignContentFromCms();

  if (result.isFailure) {
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  await dispatch(setMarketing(result.getValue()));
};
